import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import './UserAuth.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function UserAuth({ mode = 'login' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isRegister = mode === 'register';
  const [roleChosen, setRoleChosen] = useState(!!location.state?.skipChooser);
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '', referral_code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const endpoint = isRegister ? '/users-auth/register' : '/users-auth/login';
      const payload = isRegister
        ? form
        : { email: form.email, password: form.password };
      const res = await axios.post(`${API_BASE}${endpoint}`, payload);
      localStorage.setItem('saskara_user_token', res.data.token);
      localStorage.setItem('saskara_user_info', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal memproses, coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  const goToArtistPortal = () => {
    window.location.href = `https://artist.saskararecord.com/${mode}`;
  };

  return (
    <div className="user-auth-page">
      <div className="user-auth-box">
        <Link to="/" className="user-auth-logo">
          <img src="/logo.png" alt="Saskara Record" className="user-auth-logo-img" />
          SASKARA<span>RECORD</span>
        </Link>

        {!roleChosen ? (
          <>
            <p className="user-auth-subtitle">
              {isRegister ? 'Daftar sebagai...' : 'Masuk sebagai...'}
            </p>
            <div className="user-auth-role-choice">
              <button type="button" className="user-auth-role-btn" onClick={() => setRoleChosen(true)}>
                <span className="user-auth-role-btn__icon">🎧</span>
                <span className="user-auth-role-btn__label">Member</span>
                <span className="user-auth-role-btn__desc">Follow artis, beli tiket & merchandise</span>
              </button>
              <button type="button" className="user-auth-role-btn" onClick={goToArtistPortal}>
                <span className="user-auth-role-btn__icon">🎤</span>
                <span className="user-auth-role-btn__label">Artis</span>
                <span className="user-auth-role-btn__desc">Kelola lagu, profil & distribusi rilisan</span>
              </button>
            </div>
            <p className="user-auth-footer" style={{ marginTop: 20 }}>
              {isRegister ? (
                <>Sudah punya akun? <Link to="/login">Masuk di sini</Link></>
              ) : (
                <>Belum punya akun? <Link to="/register">Daftar di sini</Link></>
              )}
            </p>
          </>
        ) : (
          <>
        <p className="user-auth-subtitle">{isRegister ? 'Buat Akun Fan' : 'Masuk ke Akun Kamu'}</p>

        {error && <div className="user-auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          {isRegister && (
            <input
              type="text"
              placeholder="Nama Lengkap"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={6}
          />
          {isRegister && (
            <>
              <input
                type="tel"
                placeholder="Nomor HP (opsional)"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
              <input
                type="text"
                placeholder="Kode Referral (opsional)"
                value={form.referral_code}
                onChange={(e) => setForm({ ...form, referral_code: e.target.value })}
              />
            </>
          )}
          <button type="submit" disabled={loading}>
            {loading ? 'Memproses...' : isRegister ? 'Daftar' : 'Masuk'}
          </button>
        </form>

        {!isRegister && (
          <p className="user-auth-footer" style={{ marginTop: 10 }}>
            <Link to="/forgot-password">Lupa password?</Link>
          </p>
        )}

        <p className="user-auth-footer">
          {isRegister ? (
            <>Sudah punya akun? <Link to="/login">Masuk di sini</Link></>
          ) : (
            <>Belum punya akun? <Link to="/register">Daftar di sini</Link></>
          )}
        </p>
        <p className="user-auth-footer" style={{ marginTop: 6 }}>
          <button type="button" className="user-auth-back-btn" onClick={() => setRoleChosen(false)}>← Kembali</button>
        </p>
          </>
        )}
      </div>
    </div>
  );
}
